import { Group, TextInput } from '@mantine/core';
import InputMention from 'pages/revisions-module/template-editor/editors/InputMention';
import { IFormInputSpecIfElse } from 'pages/revisions-module/template-editor/editors/form/types';

interface IfElseInputPreviewProps {
  spec: IFormInputSpecIfElse;
}

/**
 * Preview for the if/else input type.
 */
export default function IfElseInputPreview({ spec }: IfElseInputPreviewProps) {
  return (
    <TextInput
      size="sm"
      readOnly
      placeholder="Hodnota podľa podmienky"
      description={
        <Group spacing={4} align="center" noWrap>
          Ak
          <InputMention name={spec.fieldSource || ''} />
          potom
          <InputMention name={spec.fieldTrue || ''} />
          inak
          <InputMention name={spec.fieldFalse || ''} />
        </Group>
      }
    />
  );
}
